import React, { useState } from "react";

const Footer = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <footer className="site-footer">
            <div className="footer-content">
                <p className="footer-links" onClick={toggleModal} style={{ cursor: 'pointer'}}>Legal and policies</p>
                <p className="copyright">
                    © 2025 Jian Mavrik Design. All Rights Reserved.
                </p>
            </div>

            {isModalOpen && (
                <div className="policy-modal-overlay" onClick={toggleModal}>
                    <div className="policy-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={toggleModal}>&times;</button>
                        <div className="policy-text" data-nosnippet>
                            <h2>Legal and Policies.</h2>
                            <h3>1. Introduction</h3>
                            <p>Welcome to Jian Mavrik Design. We value your privacy. This policy explains how we collect, use, and protect the information you submit via Google Ads lead forms.</p>

                            <h3>2. Information Collection</h3>
                            <p>We only collect contact information that you voluntarily provide, including:
                                Name - Phone Number - Email Address - Property Type and Design Requirements
                            </p>

                            <h3>3. How We Use Your Information</h3>
                            <p>The information collected will only be used for:</p>
                            <ul>
                                <li>To provide you with consultations and quotations for interior design or custom cabinetry.</li>
                                <li>To contact you via phone call ot WhatsApp.</li>
                            </ul>

                            <h3>4. Data Protection</h3>
                            <p>We commit that your personal information will NOT be sold, rented, or disclosed to any third-party companies or organisations.</p>

                            <h3>5. Your Rights</h3>
                            <p>If you wish for us to delete your personal information, please feel free to contact us through our official website.</p>
                        </div>
                    </div>
                </div>
            )}
        </footer>
    );
};

export default Footer;